export default defineI18nConfig(() => ({
  warnHtmlMessage: false,
  numberFormats: {
    it: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol', // Puoi usare 'symbol' o 'code'
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      percent: {
        style: 'percent',
      },
    },
  },
}))
